<footer class="d-flex justify-content-center align-items-center bg-color-from-db">
  @if (webFooterLogoBase64Data) {
    <img [src]="webFooterLogoBase64Data" class="img-fluid footer-image" alt="App footer" />
  }
</footer>
